import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MisdatosService {
  private misdatosSubject = new BehaviorSubject<any | null>(null);
  misdatos$ = this.misdatosSubject.asObservable();

  constructor() { }

  setMisDatos(misdatos: any | null) {
    this.misdatosSubject.next(misdatos);
  }
  getMisDatos(): any | null {
    return this.misdatosSubject.value;
  }
}
